// @flow

import React from 'react';
import { NavLink } from 'react-router-dom';
import './termsandconditions.scss';

type Props = {
  hideNavBar: Function,
  showNavBar: Function,
  acceptsodTnC: Function,
};

class TermsAndConditions extends React.Component<Props> {
  componentDidMount() {
    const { hideNavBar } = this.props;
    hideNavBar();
  }

  componentWillUnmount() {
    const { showNavBar } = this.props;
    showNavBar();
  }

  acceptTermsAndConditions = () => {
    const { acceptsodTnC } = this.props;
    acceptsodTnC();
  }

  render() {
    return (
      <div className="generic_modal main-content terms-and-conditions d-flex flex-column" data-toggle="modal">
        <header>
          <h1><p>Terms & Conditions</p></h1>
        </header>
        <div className="terms-and-conditions--body flex-grow-1">
          <p>Search our Database:</p>
          <p>
            {'Your personal information is confidential when you '}
            {'register with us as a member. However, when you '}
            {'register your works with us, the information relating  '}
            {'to those works is placed on our database and then some '}
            {'of that information can then be viewed by all those who  '}
            {'have signed up to use our Online Services. This includes '}
            {'all other PRS for Music members. The information that '}
            {'can be seen via Online Services includes the names of all the  '}
            {'writers or composers of the work, the associated publishers '}
            {'and the shares which each may hold in the works. '}
          </p>
          <p>
            {'Access to the Online Services is subject to strict terms and  '}
            {'conditions; members can only use the service for the purpose of '}
            {'checking their interests in musical works are correctly registered.'}
          </p>
          <p>
            {'"Confidential Information" means all confidential, '}
            {'commercial and technical information, data, know-how, '}
            {'information concerning the Licensed Service, PRS for Music, '}
            {'MCPS and the members of MCPS and PRS for Music.  For the '}
            {'avoidance of doubt, it includes all data and information made '}
            {'available through the Licensed Service.   '}
          </p>
          <p>
            The
            <a href="https://www.prsformusic.com/terms-of-use/members-terms" target="_blank" rel="noopener noreferrer" className="" style={{ color: 'black' }}>
              <b>terms and conditions </b>
            </a>
            {'make it very clear that there can be no other use of the '}
            {'information and no disclosure of it to any third parties. '}
            {'Any breach of the terms and conditions will be taken seriously '}
            {'and steps will be taken to ensure they are dealt with appropriately. '}
          </p>
        </div>
        <footer>
          <button
            onClick={this.acceptTermsAndConditions}
            className="btn btn-prs lime-bg btn-block"
            type="button"
          >
            Proceed
          </button>
          <NavLink to="/" className="btn btn-prs btn-outline-light btn-block">Cancel</NavLink>
        </footer>
      </div>
    );
  }
}

export default TermsAndConditions;
